import { render, staticRenderFns } from "./DeliveryMethodForm.vue?vue&type=template&id=9824e1e2&"
import script from "./DeliveryMethodForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryMethodForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports